var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLockIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Leading icon?"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00014 0.5C5.61297 0.5 3.43115 2.06078 3.43115 5.26863V7.04902C2.43864 7.17451 1.94238 7.76275 1.94238 8.87647V14.6412C1.94238 15.9196 2.58409 16.5 3.86752 16.5H12.1328C13.4162 16.5 14.0579 15.9196 14.0579 14.6412V8.87647C14.0579 7.76275 13.5616 7.17451 12.5691 7.04902V5.26863C12.5691 2.06078 10.3873 0.5 8.00014 0.5ZM4.80856 5.09608C4.80856 2.90784 6.22888 1.70784 8 1.70784C9.76257 1.70784 11.1914 2.90784 11.1914 5.09608V7.01765H4.80856V5.09608ZM12.0904 8.2019C12.4925 8.2019 12.6807 8.35877 12.6807 8.79014V14.7196C12.6807 15.1588 12.4925 15.3235 12.0904 15.3235H3.91069C3.5171 15.3235 3.32031 15.1588 3.32031 14.7196V8.79014C3.32031 8.35877 3.5171 8.2019 3.91069 8.2019H12.0904Z",
    fill: "#414141"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcon);
export default __webpack_public_path__ + "static/media/lockIcon.2277582a261d809e233270bdfb0d6475.svg";
export { ForwardRef as ReactComponent };